/* eslint-disable arrow-parens */
import React, { Component } from 'react';
import { ScriptCache } from '../../lib/ScriptCache';
import { GoogleApi } from '../../lib/GoogleApi';

const defaultCreateCache = options => {
  const opts = options || {};
  const { apiKey, client } = opts;
  const libraries = opts.libraries || ['places'];
  const version = opts.version || '3.31';
  const language = opts.language || 'en';
  const region = opts.region || 'US';
  const channel = opts.channel || 'trip_planner';

  return ScriptCache({
    google: GoogleApi({
      apiKey,
      language,
      libraries,
      version,
      region,
      client,
      channel,
    }),
  });
};

const wrapper = options => WrappedComponent => {
  const createCache = options.createCache || defaultCreateCache;

  class Wrapper extends Component {
    constructor(props, context) {
      super(props, context);

      this.scriptCache = createCache(options);
      this.scriptCache.google.onLoad(this.onLoad.bind(this));

      this.state = {
        loaded: false,
      };
    }

    onLoad() {
      this.GAPI = window.google;

      this.setState({ loaded: true });
    }

    render() {
      const props = Object.assign({}, this.props, {
        // eslint-disable-next-line react/destructuring-assignment
        loaded: this.state.loaded,
        google: window.google,
      });

      return (
        <div>
          <WrappedComponent {...props} />
        </div>
      );
    }
  }

  return Wrapper;
};

export default wrapper;
